import {ExtraOptions, RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {AuthLayoutComponent} from './layout/auth-layout/auth-layout.component';
import {FullLayoutComponent} from './layout/full-layout/full-layout.component';
import {PageNotFoundComponent} from '@shared/components/page-not-found/page-not-found.component';
import {NoAuthGuard} from '@app/guard/no-auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/explore',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AuthLayoutComponent,
    loadChildren: () => import('@modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'explore',
    component: FullLayoutComponent,
    loadChildren: () => import('@modules/explore/explore.module').then(m => m.ExploreModule)
  },
  {
    path: 'view-all-research',
    component: FullLayoutComponent,
    loadChildren: () => import('@modules/reports/reports.module').then(m => m.ReportsModule)
  },
  {
    path: 'saved-vehicles',
    component: FullLayoutComponent,
    loadChildren: () => import('@modules/saved-vehicles/saved-vehicles.module').then(m => m.SavedVehiclesModule)
  },
  // {
  //   path: 'billing',
  //   component: FullLayoutComponent,
  //   loadChildren: () => import('@modules/billing/billing.module').then(m => m.BillingModule)
  // },
  {
    path: 'settings',
    component: FullLayoutComponent,
    loadChildren: () => import('@modules/settings/settings.module').then(m => m.SettingsModule)
  },
  // {
  //   path: 'create-research',
  //   component: FullLayoutComponent,
  //   loadChildren: () => import('@modules/create-report/create-report.module').then(m => m.CreateReportModule)
  // },
  // {
  //   path: 'finalize-research',
  //   component: FullLayoutComponent,
  //   loadChildren: () => import('@modules/finalize-report/finalize-report.module').then(m => m.FinalizeReportModule)
  // },
  {
    path: 'q/:reportId',
    component: FullLayoutComponent,
    loadChildren: () => import('@modules/view-quick-report/view-quick-report.module').then(m => m.ViewQuickReportModule)
  },
  // {
  //   path: 'r/:reportId',
  //   component: FullLayoutComponent,
  //   loadChildren: () => import('@modules/view-report/view-report.module').then(m => m.ViewReportModule)
  // },
  {
    path: 'vehicle/:vehicleId',
    component: FullLayoutComponent,
    loadChildren: () => import('@modules/view-vehicle/view-vehicle.module').then(m => m.ViewVehicleModule)
  },
  {
    path: 'blogs',
    component: FullLayoutComponent,
    loadChildren: () => import('@modules/blog/blog.module').then(m => m.BlogModule)
  },
  {
    path: 'blog',
    component: FullLayoutComponent,
    loadChildren: () => import('@modules/view-blog/view-blog.module').then(m => m.ViewBlogModule)
  },
  {
    path: 'use-cases/:useCaseId',
    component: FullLayoutComponent,
    loadChildren: () => import('@static/use-case/use-case.module').then(m => m.UseCaseModule)
  },
  {
    path: 'sample-research',
    component: FullLayoutComponent,
    loadChildren: () => import('@static/sample-reports/sample-reports.module').then(m => m.SampleReportsModule)
  },
  {
    path: 'terms',
    component: FullLayoutComponent,
    loadChildren: () => import('@static/terms/terms.module').then(m => m.TermsModule)
  },
  {
    path: 'privacy',
    component: FullLayoutComponent,
    loadChildren: () => import('@static/privacy/privacy.module').then(m => m.PrivacyModule)
  },
  {
    path: 'legal-faq',
    component: FullLayoutComponent,
    loadChildren: () => import('@static/legal-faq/legal-faq.module').then(m => m.LegalFaqModule)
  },
  {
    path: 'about',
    component: FullLayoutComponent,
    loadChildren: () => import('@static/about-us/about-us.module').then(m => m.AboutUsModule)
  },
  {
    path: 'faqs',
    component: FullLayoutComponent,
    loadChildren: () => import('@static/faqs/faqs.module').then(m => m.FaqsModule)
  },
  {
    path: 'services',
    component: FullLayoutComponent,
    loadChildren: () => import('@static/services/services.module').then(m => m.ServicesModule)
  },
  {
    path: '404',
    component: FullLayoutComponent,
    children: [
      {
        path: '',
        component: PageNotFoundComponent,
        canActivate: [NoAuthGuard]
      }
    ]
  },
  {path: '**', redirectTo: '404'}
];

const config: ExtraOptions = {
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'enabled',
  initialNavigation: 'enabledBlocking'
};

// Handle index.html request on Cloud Functions
if (typeof process !== 'undefined' && process.env?.FUNCTION_NAME) {
  routes.push({
    path: 'index.html',
    redirectTo: '/explore',
    pathMatch: 'full'
  });
}

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
